

import TextInput from "/src/components/UI/TextField/TextInput"
import './InputSearch.css';
import "/src/assets/css/polices.css"
import { useRef } from "react";
function InputSearch({ name, timeout = 500, placeholderLibelle, onChange, style = {}, defaultValue }) {

    const typingTimer = useRef(null);
    const onKeyUp = (e) => {
        clearTimeout(typingTimer.current);
        typingTimer.current = setTimeout(() => onChange(e), timeout);
    }
    return (
        <>
            <div className="inputSearch-container" style={{...style}}>
                <TextInput onKeyUp={onKeyUp} className="inputSearch placeholder-input" placeholder={placeholderLibelle} name={name} defaultValue={defaultValue}></TextInput>
            </div>
        </>

    )
}

export default InputSearch
